import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

export const AddRequiredFileToDocumentationRequiredSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      fileTypeId: z.string().nullable(),
    })
    .refine(
      (data) => {
        return data.fileTypeId !== null;
      },
      {
        message: t('REQUIRED_FIELD'),
        path: ['fileTypeId'],
      },
    );

export type AddRequiredFileToDocumentationRequiredType = z.infer<
  ReturnType<typeof AddRequiredFileToDocumentationRequiredSchema>
>;
